export default __webpack_public_path__ + "static/media/gapstack-logo.c4eeaaad.svg";